import { mapModifierGroup, mapModifierOption } from '@/entities/product/model/mapModifierGroup'

export function mapModifierTemplatesPayload(data) {
  const variantGroups = (Array.isArray(data) ? data : [])
    .map(mapModifierGroup)
    .filter(
      (group) =>
        group.id &&
        group.id !== 'toppings' &&
        group.type === 'single' &&
        group.options.length,
    )
    .map((group) => ({
      ...group,
      options: group.options.map((option) => ({
        ...option,
        priceDelta: 0,
        isDefault: false,
      })),
    }))

  return { variantGroups }
}

export function mapToppingOptionsPayload(data) {
  return (Array.isArray(data) ? data : [])
    .map(mapModifierOption)
    .filter((option) => option.id && option.title)
    .map((option) => ({
      id: option.id,
      title: option.title,
      priceDelta: 0,
    }))
}

export function emptyModifierTemplates() {
  return { variantGroups: [], toppings: [] }
}
